import { createSelector } from "reselect";

export function createDataRootSelector(resourceSelector) {
  return createSelector(
    resourceSelector,
    resource => resource.data
  );
}
